import type {
  BolusEvent,
  CGMSessionEndedEvent,
  DeviceChangeEvent,
  PumpSuspensionEvent,
} from "@tandemdiabetes/sugarmate-api-react-client"
import { ActivityType } from "@tandemdiabetes/sugarmate-api-react-client"
import { ModalContent } from "@tandemdiabetes/sugarmate-react-components"

import { BolusEventModal } from "./BolusEventModal"
import { CGMSessionEndedEventModal } from "./CGMSessionEndedEventModal"
import { DeviceChangeEventModal } from "./DeviceChangeEventModal"
import { PumpSuspensionEventModal } from "./PumpSuspensionEventModal"
import type { ReadOnlyUserEvent } from "src/types"

interface Props {
  userEvent: ReadOnlyUserEvent;
}

export function EventModalContent(props: Props) {
  const { userEvent } = props

  function renderContent() {
    switch (userEvent.event_type) {
      case ActivityType.Bolus:
        return (
          <BolusEventModal userEvent={userEvent as BolusEvent} />
        )
      case ActivityType.CGMSessionEnded:
        return (
          <CGMSessionEndedEventModal userEvent={userEvent as CGMSessionEndedEvent} />
        )
      case ActivityType.DeviceChange:
        return (
          <DeviceChangeEventModal userEvent={userEvent as DeviceChangeEvent} />
        )
      case ActivityType.PumpSuspension:
        return (
          <PumpSuspensionEventModal userEvent={userEvent as PumpSuspensionEvent} />
        )
      default:
        return null
    }
  }

  return (
    <ModalContent>
      {renderContent()}
    </ModalContent>
  )
}
